// Phase 1A Step 34 — Section 10 Footer.
// Verbatim port from handoff/landing-reference/sections.jsx Footer + FooterFlag.

import { Logo } from "./Logo.tsx";

interface FooterFlagProps {
  code: "GH" | "NG";
  country: string;
  status: string;
}

function FooterFlag({ code, country, status }: FooterFlagProps): JSX.Element {
  const flag =
    code === "GH" ? (
      <svg width="28" height="18" viewBox="0 0 28 18" style={{ display: "block" }}>
        <rect width="28" height="6" y="0" fill="#CE1126" />
        <rect width="28" height="6" y="6" fill="#FCD116" />
        <rect width="28" height="6" y="12" fill="#006B3F" />
        <polygon
          points="14,7.2 14.7,9.4 17,9.4 15.15,10.7 15.85,12.9 14,11.55 12.15,12.9 12.85,10.7 11,9.4 13.3,9.4"
          fill="#000"
        />
      </svg>
    ) : (
      <svg width="28" height="18" viewBox="0 0 28 18" style={{ display: "block" }}>
        <rect width="9.33" height="18" x="0" fill="#008751" />
        <rect width="9.34" height="18" x="9.33" fill="#FFF" />
        <rect width="9.33" height="18" x="18.67" fill="#008751" />
      </svg>
    );
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      {flag}
      <div>
        <div
          className="mono"
          style={{
            fontSize: 11,
            color: "var(--text)",
            letterSpacing: "0.14em",
            fontWeight: 500,
          }}
        >
          {country}
        </div>
        <div
          className="mono"
          style={{
            fontSize: 9,
            color: "var(--success)",
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            display: "flex",
            alignItems: "center",
            gap: 5,
          }}
        >
          <span className="live-dot" style={{ width: 4, height: 4 }} />
          {status}
        </div>
      </div>
    </div>
  );
}

const FOOTER_COLS: ReadonlyArray<{ h: string; links: ReadonlyArray<string> }> = [
  {
    h: "Product",
    links: ["The Engine", "Agents", "Rollover", "Pricing", "Changelog"],
  },
  {
    h: "Company",
    links: ["About", "Careers", "Press", "Contact"],
  },
  {
    h: "Legal",
    links: ["Terms", "Privacy", "Responsible Play", "Data Protection · Act 843", "Compliance"],
  },
];

const SOCIAL: ReadonlyArray<string> = ["X", "IG", "TG", "YT"];

export function LandingFooter(): JSX.Element {
  return (
    <footer
      style={{
        padding: "80px 0 32px",
        background: "linear-gradient(180deg, #0A0A0A 0%, #060606 100%)",
        borderTop: "1px solid var(--border)",
      }}
    >
      <div className="container">
        <div
          className="sz-l-footer-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "1.6fr 1fr 1fr 1fr",
            gap: 60,
            marginBottom: 60,
          }}
        >
          <div>
            <Logo size={28} />
            <p
              style={{
                marginTop: 22,
                fontSize: 13,
                color: "var(--text-muted)",
                lineHeight: 1.6,
                maxWidth: 320,
              }}
            >
              A betting intelligence terminal for serious West African bettors. Built in Accra.
              Tested across two markets. Compounding what most leave to chance.
            </p>
            <div style={{ display: "flex", gap: 24, marginTop: 28 }}>
              <FooterFlag code="GH" country="Ghana" status="Live" />
              <FooterFlag code="NG" country="Nigeria" status="Live" />
            </div>
          </div>

          {FOOTER_COLS.map((col, i) => (
            <div key={i}>
              <div
                className="mono"
                style={{
                  fontSize: 10,
                  color: "var(--accent)",
                  letterSpacing: "0.18em",
                  textTransform: "uppercase",
                  marginBottom: 18,
                }}
              >
                {col.h}
              </div>
              <ul
                style={{
                  listStyle: "none",
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                  padding: 0,
                }}
              >
                {col.links.map((l, j) => (
                  <li key={j}>
                    <a style={{ fontSize: 13, color: "var(--text)", cursor: "pointer" }}>{l}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom strip */}
        <div
          className="sz-l-footer-bottom"
          style={{
            paddingTop: 28,
            borderTop: "1px solid var(--border)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 20,
          }}
        >
          <div
            className="mono"
            style={{
              fontSize: 11,
              color: "var(--text-dim)",
              letterSpacing: "0.1em",
            }}
          >
            © 2026 STRIKZA Labs Ltd. · Registered in Ghana
          </div>
          <div style={{ display: "flex", gap: 18 }}>
            {SOCIAL.map((s) => (
              <a
                key={s}
                className="mono"
                style={{
                  fontSize: 11,
                  color: "var(--text-muted)",
                  letterSpacing: "0.14em",
                  width: 30,
                  height: 30,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid var(--border-bright)",
                  cursor: "pointer",
                }}
              >
                {s}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
